export { default as HeartSolidIcon } from './HeartSolidIcon';
